import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onToggle
}: FAQItemProps) {
  return <div className="border-b border-[#c9a96e]/20 last:border-b-0" data-id="element-33">
      <button onClick={onToggle} className="w-full py-6 flex items-center justify-between text-left focus:outline-none focus:ring-2 focus:ring-[#c9a96e]/50 focus:ring-offset-2 focus:ring-offset-[#1a2342] rounded-lg" aria-expanded={isOpen} data-id="element-34">
        <span className="font-['Playfair_Display'] text-lg md:text-xl font-semibold text-[#f0ebe3] pr-4" data-id="element-35">
          {question}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3
      }} className="flex-shrink-0" data-id="element-36">
          <ChevronDownIcon className="w-6 h-6 text-[#c9a96e]" data-id="element-37" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-38">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-39">
            <p className="pb-6 text-[#a0998e] leading-relaxed" data-id="element-40">{answer}</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: '¿Realmente puedo sentirme mejor en solo 3 días?',
    answer: 'No estarás "curada", pero el pánico obsesivo se detendrá. Lograrás pasar de la desesperación a la calma funcional. El objetivo no es olvidarlo instantáneamente, sino recuperar el control de tus pensamientos y emociones.'
  }, {
    question: '¿Tengo que bloquearlo para siempre?',
    answer: 'El protocolo pide 72 horas. Después de eso, tú decidirás desde la lógica, no desde la adicción. Muchas mujeres descubren que después de los 3 días, ya no sienten la necesidad urgente de revisar sus redes.'
  }, {
    question: '¿Funciona si fue una relación larga?',
    answer: 'Sí, porque la química de la obsesión funciona igual si duraron 10 años o 3 meses. El cerebro procesa el rechazo de la misma manera, independientemente de la duración de la relación.'
  }, {
    question: '¿Es seguro el pago?',
    answer: 'Sí, utilizamos encriptación de grado bancario para procesar tu acceso instantáneo. Tu información está completamente protegida y el cargo aparecerá de forma discreta en tu estado de cuenta.'
  }];
  return <section className="w-full bg-[#1a2342] py-20 md:py-28" data-id="element-41">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-42">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-43">
          <h2 className="font-['Playfair_Display'] text-3xl sm:text-4xl font-bold text-[#f0ebe3]" data-id="element-44">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="bg-[#0f1629]/60 rounded-2xl p-6 md:p-8" data-id="element-45">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onToggle={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-46" />)}
        </motion.div>
      </div>
    </section>;
}